module.exports = __webpack_public_path__ + "static/img/logo02.356877e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo02.jpg
// module id = GX3T
// module chunks = 1